import Header from "~/ui/header";
import { fetchUserIcon } from "~/util/dashboard";
import createHeaderButton from "~/ui/headerbutton";
import { SHARE_FILLED_16 } from "@sznds/icons";
import Dashboard from "./dashboard";
import Reviews from "./reviews";
import Content from "./content";
import { node } from "~/util/dom";
import { _ } from "~/i18n";
import MyMapsShare from "~/es6/mymaps.share";
import { CONFIG } from "~/config";

export default class UserProfile {
	_container: HTMLDivElement;

	_header: Header;

	_active: boolean;

	_userId: string;

	_data: any;

	// aktualne zobrazeny content
	_activeContent: Content;

	// posledni parametr upc z state
	_upc: string;

	constructor() {
		this._container = node("div", { className: "user-profile-container" });
		this._header = new Header({
			title: "",
		});
		this._container.appendChild(this._header.node);
		this._activeContent = null;
		this._upc = "";
	}

	get container() {
		return this._container;
	}

	activate() {
		if (this._active) {
			return this;
		}

		this._active = true;
		this.show();

		return this;
	}

	deactivate() {
		if (!this._active) {
			return this;
		}

		this._active = false;

		return this;
	}

	show() {
		this._container.classList.remove("hide");

		if (this._activeContent) {
			this._activeContent.show();
		}
	}

	hide() {
		this._container.classList.add("hide");

		if (this._activeContent) {
			this._activeContent.hide();
		}
	}

	async setState(state) {
		if (!state.up) {
			return;
		}

		this._userId = state.up;
		this._upc = state.upc || "";

		// nacteni ikony uzivatele
		try {
			const response = await fetchUserIcon(this._userId);
			const json = await response.json();

			if (json.data?.privateUrl) {
				this._header.avatar = `${json.data?.privateUrl}/64`;
			}
		} catch (ex) {
			// eslint-disable-next-line no-console
			console.log(ex);
		}

		// odstraneni stareho obsahu stranky
		if (this._activeContent) {
			this._activeContent.node.remove();
			this._activeContent.destroy();
			this._header.leftButtons.innerHTML = "";
		}

		// novy obsah stranky
		switch (this._upc) {
			case "":
				this._activeContent = new Dashboard({
					userId: this._userId,
					header: this._header,
				});
				Mapy.getComponent("logger").log("view", { text: "dashboard", publicProfile: "1" });
				break;

			case "reviews":
				this._activeContent = new Reviews({
					userId: this._userId,
					header: this._header,
					direct: "direct" in state ? state.direct : true,
					...state.backAction ? { backAction: state.backAction } : {},
				});
				Mapy.getComponent("logger").log("view", { text: "reviews", publicProfile: "1" });
				break;

			default:
				//
		}

		this._container.appendChild(this._activeContent.node);
		if (this._active) {
			this._activeContent.show();
		}

		// sdileci tlacitko
		// je treba promazat predchozi tlacitka, protoze hlavicka zustava a tedy by se tlacitka mnozila
		this._header.rightButtons.innerHTML = "";
		const shareButton = createHeaderButton({
			icon: SHARE_FILLED_16,
			innerHTML: _("mymap.contextMenu.share"),
		});

		shareButton.setAttribute("data-log-publicProfile", "1");
		this._header.rightButtons.appendChild(shareButton);
		shareButton.addEventListener("click", () => {
			let sharePopup = new MyMapsShare({
				type: this._upc === "reviews" ? "publicReviews" : "publicDashboard",
				url: `${location.protocol}//${CONFIG.BASE_URL}/?up=${this._userId}${this._upc === "" ? "" : `&upc=${this._upc}`}`,
				noFrame: true,
				analytics: {
					publicProfile: "1",
				},
			}, () => {
				sharePopup.destroy();
				sharePopup = null;
			});

			sharePopup.open();
		});
	}

	getState() {
		return this._userId
			? {
				up: this._userId,
				...this._upc === "" ? {} : { upc: this._upc },
			}
			: {};
	}
}
